// Resolves customer logo filenames (stored on the customers.custom_logo column)
// to bundled asset URLs from frontend/src/assets/customer-logos/.
// Both SVG and raster images are supported; consumers render via <img>.

const modules = import.meta.glob(
    '../assets/customer-logos/*.{svg,png,jpg,jpeg,webp,gif}',
    { eager: true, query: '?url', import: 'default' }
);

const logoMap = {};
for (const [path, url] of Object.entries(modules)) {
    const filename = path.split('/').pop();
    if (filename) logoMap[filename.toLowerCase()] = url;
}

export function getCustomerLogoUrl(filename) {
    if (!filename || typeof filename !== 'string') return null;
    return logoMap[filename.trim().toLowerCase()] ?? null;
}
